export default __webpack_public_path__ + "static/media/aeroStub.0d81bcff.png";